import React from 'react';
import * as Styles from '../../../../../SharedModules/StyleConstant/StyleConstant';
import { cellRenderer } from '../../../../../SharedModules/utilities/utilities';

function amountComparator(amount1, amount2) {
  let amt1 = null;
  let amt2 = null;
  if (amount1 && amount1?.toString()?.includes('$')) {
    amt1 = parseFloat(
      amount1?.toString().split('$')[1]?.toString()?.replace(',', '').trim()
    );
  } else {
    amt1 = parseFloat(amount1?.toString()?.replace(',', '').trim());
  }
  if (amount2 && amount2?.toString()?.includes('$')) {
    amt2 = parseFloat(
      amount2?.toString().split('$')[1]?.toString()?.replace(',', '').trim()
    );
  } else {
    amt2 = parseFloat(amount2?.toString()?.replace(',', '').trim());
  }
  if (amt1 === null && amt2 === null) {
    return 0;
  }
  if (amt1 === null) {
    return -1;
  }
  if (amt2 === null) {
    return 1;
  }

  return amt1 - amt2;
}

export const dateComparator = (valA, valB) => {
  return Number(new Date(valA)) - Number(new Date(valB));
};
const comparatorQtr = (a, b) => {
  const splittedQtrA = a.split('Q');
  const splittedQtrB = b.split('Q');
  return splittedQtrA[1] - splittedQtrB[1] || splittedQtrA[0] - splittedQtrB[0];
};
export const TableHead = [
  {
    headerName: 'Invoice Number',
    field: 'invoiceNum',
    editable: false,
    suppressMenu: false,
    sortable: true,
    minWidth: Styles.Width_130,
    cellRenderer: 'StartQtrTextbox',
    cellEditorParams: {
      maxLength: 6,
      custWidth: '135px',
    },
    cellStyle: { borderRightColor: Styles.BorderColor },
    custClass: 'tbill-rate-editable-input',
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },

  {
    headerName: 'Manufacturer ID',
    field: 'mfgId',
    editable: false,
    suppressMenu: false,
    sortable: true,
    sort: 'asc',
    minWidth: Styles.Width_171,
    cellEditorParams: {
      maxLength: 6,
      custWidth: '135px',
    },
    cellStyle: { borderRightColor: Styles.BorderColor },
    custClass: 'tbill-rate-editable-input',
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'endsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Manufacturer Name',
    field: 'mfgName',
    editable: false,
    suppressMenu: false,
    sortable: true,
    minWidth: Styles.Width_250,
    // cellRenderer: 'GenericCodeTextBox',
    cellRenderer: 'TextBoxRender',
    cellClass: 'frr-ellipsis-text',
    cellEditorParams: {
      maxLength: 5,
      custWidth: '135px',
    },
    cellStyle: { borderRightColor: Styles.BorderColor },
    wrapText: true,
    custClass: 'tbill-rate-editable-input',
    columnSpan: 3,
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: '',
    field: '',
    removeColumn: true,
    minWidth: 1,
    resizable: false,
    editable: false,
  },
  {
    headerName: '',
    field: '',
    removeColumn: true,
    minWidth: 1,
    resizable: false,
    editable: false,
  },
  {
    headerName: 'Current Quarter Amount',
    field: 'totCurrQtrAmt',
    // valueFormatter: dollarFormatter,
    cellRenderer: cellRenderer,
    editable: false,
    suppressMenu: false,
    sortable: true,
    minWidth: Styles.Width_167,
    // cellRenderer: 'GenericCodeTextBox',
    cellEditorParams: {
      maxLength: 10,
      custWidth: '135px',
    },
    cellStyle: { borderRightColor: Styles.BorderColor, textAlign: 'right' },
    custClass: 'tbill-rate-editable-input',
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    printPrefixValue: '$',
    isTextColorRed: true,
  },
  {
    headerName: 'Unit Changes Amount',
    cellRenderer: cellRenderer,
    field: 'totUnitChangesAmt',
    // valueFormatter: dollarFormatter,
    editable: false,
    suppressMenu: false,
    sortable: true,
    minWidth: Styles.Width_167,

    cellEditorParams: {
      maxLength: 5,
      custWidth: '135px',
    },
    cellStyle: { borderRightColor: Styles.BorderColor, textAlign: 'right' },
    custClass: 'tbill-rate-editable-input',
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    printPrefixValue: '$',
    isTextColorRed: true,
  },
  {
    headerName: 'Informational Amount',
    cellRenderer: cellRenderer,
    field: 'totInformationalAmt',
    // valueFormatter: dollarFormatter,
    editable: false,
    suppressMenu: false,
    sortable: true,
    minWidth: Styles.Width_171,

    cellEditorParams: {
      maxLength: 5,
      custWidth: '135px',
    },
    cellStyle: { borderRightColor: Styles.BorderColor, textAlign: 'right' },
    custClass: 'tbill-rate-editable-input',
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    printPrefixValue: '$',
    isTextColorRed: true,
  },
  {
    headerName: 'Interest Due',
    field: 'interestDue',
    // valueFormatter: dollarFormatter,
    cellRenderer: cellRenderer,
    editable: false,
    suppressMenu: false,
    sortable: true,
    minWidth: Styles.Width_167,
    // cellRenderer: 'GenericCodeTextBox',
    cellEditorParams: {
      maxLength: 5,
      custWidth: '135px',
    },
    cellStyle: { borderRightColor: Styles.BorderColor, textAlign: 'right' },
    custClass: 'tbill-rate-editable-input',
    filter: 'agTextColumnFilter',
    printPrefixValue: '$',
    isTextColorRed: true,
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Total Balance',
    // valueFormatter: dollarFormatter,
    cellRenderer: cellRenderer,
    field: 'totalBal',
    editable: false,
    suppressMenu: false,
    sortable: true,
    minWidth: Styles.Width_167,
    comparator: amountComparator,
    cellEditorParams: {
      maxLength: 5,
      custWidth: '135px',
    },
    cellStyle: { borderRightColor: Styles.BorderColor, textAlign: 'right' },
    custClass: 'tbill-rate-editable-input',
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    printPrefixValue: '$',
    isTextColorRed: true,
  },
  {
    headerName: 'Invoice Handling Code',
    field: 'invoiceHandlingCd',
    editable: false,
    suppressMenu: false,
    sortable: true,
    minWidth: Styles.Width_150,
    cellRenderer: 'GenericCodeTextBox',
    cellEditorParams: {
      maxLength: 5,
      custWidth: '135px',
    },
    cellStyle: { borderRightColor: Styles.BorderColor },
    custClass: 'tbill-rate-editable-input',
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },

  {
    headerName: 'Electronic Distribution Ind',
    field: 'electDist',
    // cellRendererFramework: (params) => {
    //   if (params.colDef.field === 'electDist') {
    //     return (
    //       <Checkbox
    //         checked={
    //           !(
    //             params.data.cdCreateDt === null &&
    //             params.data.invoiceUploadedDt === null
    //           )
    //         }
    //         color="primary"
    //         disabled
    //       />
    //     );
    //   } else {
    //     return '';
    //   }
    // },
    editable: false,
    showCheckboxIcon: true,
    sortable: false,
    hideFilterIcon: true,
    minWidth: Styles.Width_130,
    sortingOrder: ['desc', 'asc'],
    cellStyle: { 'border-right-color': Styles.BorderColor },
    filter: false,
    cellRenderer: 'CheckBoxSelectedForRCellRender',
    alignment: 'center',
    checkbox: true,
  },

  {
    headerName: 'Freeze date',
    field: 'invoiceFreezeDt',
    editable: false,
    suppressMenu: false,
    sortable: true,
    minWidth: Styles.Width_120,
    cellRenderer: 'GenericCodeTextBox',
    cellEditorParams: {
      maxLength: 5,
      custWidth: '135px',
    },
    comparator: dateComparator,
    cellStyle: { borderRightColor: Styles.BorderColor },
    custClass: 'tbill-rate-editable-input',
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Original Qtr',
    field: 'qtr',
    editable: false,
    suppressMenu: false,
    sortable: true,
    minWidth: Styles.Width_138,
    cellRenderer: 'GenericCodeTextBox',
    cellEditorParams: {
      maxLength: 5,
      custWidth: '135px',
    },
    comparator: comparatorQtr,
    cellStyle: { borderRightColor: Styles.BorderColor },
    custClass: 'tbill-rate-editable-input',
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
];
